/* eslint-disable react/no-unstable-nested-components */
import { FormattedMessage } from "react-intl";

/* eslint-disable jsx-a11y/accessible-emoji */
interface NoCommentsBlankslateProps {
  viewerCanComment: boolean;
}

export default function NoCommentsBlankslate({ viewerCanComment }: NoCommentsBlankslateProps) {
  return (
    <div className="m-4 rounded-md bg-slate-100 p-4 font-aeonik font-normal text-slate-500 dark:bg-orange-600/10 dark:text-orange-400">
      {viewerCanComment ? (
        <p className="text-center">
          <FormattedMessage
            defaultMessage="Ainda não tem nenhum comentário por aqui. <strong>Que tal você fazer o primeiro?</strong>"
            id="Q11phX"
            values={{
              strong: (text) => <strong>{text}</strong>,
            }}
          />{" "}
          💬🤩
        </p>
      ) : (
        <p className="text-center">
          <FormattedMessage
            defaultMessage="Ainda não tem nenhum comentário por aqui— <em> <strong>que pena que você não é Premium</strong> para poder fazer o primeiro. </em>"
            id="monWPI"
            values={{
              strong: (text) => <strong>{text}</strong>,
              em: (children) => <em>{children}</em>,
            }}
          />{" "}
          😕
        </p>
      )}
    </div>
  );
}
